import AppFrame from './components/AppFrame/index';

function App() {
  return <AppFrame />;
}

export default App;
